


















import { Vue, Component, Model } from 'vue-property-decorator';
import ContentDialog from '@/components/content-dialog.vue';

@Component({
  components: {
    ContentDialog,
  },
})
export default class SalesChannelDialog extends Vue {
  @Model('change', { default: false })
  show!: boolean;
}
